import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'additionalInfo'
})
export class AdditionalInfoPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: any, args?: any): any {
    if (!value) {
      return;
    }
    if (value) {
      return value[this.translate.getDefaultLang()]
    }
  }

}
